import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/deduction-actions';
import { DeductionActions } from '../constants';
import { IDeduction } from 'src/types/deduction';

export interface DeductionState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IDeduction>;
    current: IDeduction | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function deductions(state: DeductionState = initialState, action: Actions | any): DeductionState {
    switch (action.type) {
        case requestType(DeductionActions.PERSIST_DEDUCTION):
            return { ...state, error: '', inProgress: true };
        case successType(DeductionActions.PERSIST_DEDUCTION):
            return { ...state, inProgress: false };
        case failureType(DeductionActions.PERSIST_DEDUCTION):
            return { ...state, error: action.error, inProgress: false };

        case requestType(DeductionActions.FETCH_DEDUCTIONS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(DeductionActions.FETCH_DEDUCTIONS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(DeductionActions.FETCH_DEDUCTIONS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(DeductionActions.FETCH_DEDUCTION):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(DeductionActions.FETCH_DEDUCTION):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(DeductionActions.FETCH_DEDUCTION):
            return { ...state, inProgress: false, error: action.error };
        case requestType(DeductionActions.DELETE_DEDUCTION):
            return { ...state, error: '', inProgress: true };
        case successType(DeductionActions.DELETE_DEDUCTION):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IDeduction) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(DeductionActions.DELETE_DEDUCTION):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
